import { render, staticRenderFns } from "./loading-view.vue?vue&type=template&id=443f1fde&scoped=true&"
import script from "./loading-view.vue?vue&type=script&lang=js&"
export * from "./loading-view.vue?vue&type=script&lang=js&"
import style0 from "./loading-view.vue?vue&type=style&index=0&id=443f1fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f1fde",
  null
  
)

export default component.exports